<template lang="pug">
  section.section.list-item
    article.media(v-if="!editing")
      figure.media-left.handle
        p.image.is-128x128.drag-handle
          a(:href="item.link", target="_blank", v-if="item.link")
            template( v-if="item.image_url")
              img(:src="item.image_url")
            template(v-else-if="myList")
              b-tooltip(label="Pack selbst ein Bild rein!", position="is-bottom")
                img(src="../assets/default_gift.png", v-if="!item.image_url")
            template(v-else)
              img(src="../assets/default_gift.png", v-if="!item.image_url")
          img(src="../assets/default_gift.png", v-if="!item.link")
      .media-content
        .content
          p
            a(:href="item.link", v-if="item.link", target="_blank")
              strong {{ linkName | truncate(40) }}
            strong(v-if="!item.link") {{ item.name}}
            br
            span(v-html="$options.filters.linebreaks(item.description)")
          span.price(v-if="item.price") {{ item.price }}

          button.button.reservation(
            :class="{'is-danger': item.reserved_by, 'is-success': !item.reserved_by}",
            @click="toggleReservation", v-html="reservationText",
            v-show="showReservationButton")
      .media-right
        b-dropdown.item-menu(hoverable, position="is-bottom-left", v-show="myList")
          b-icon.burger(icon="menu", slot="trigger", :class="{'drag-handle': myList}")
          a.dropdown-item(v-if="reservedByMe" @click="toggleReservation")
            b-icon.is-small(icon="close")
            |  Reservierung löschen
          a.dropdown-item(@click="startEditing")
            b-icon.is-small(icon="pencil")
            |  Bearbeiten
          a.dropdown-item.drag-handle(v-if="myList")
            b-icon.is-small(icon="swap-vertical")
            |  Verschieben
          a.dropdown-item(@click="deleteItem", v-show="myList")
            b-icon.is-small(:icon="deleteIcon", :class="{'wiggle': deletionTriggered}")
            |  {{ deleteText}}

      .overlay(v-show="showOverlay")
        a(:href="item.link", v-if="item.link", target="_blank")
          img(src="../assets/reserved.png")

      .me-wants(v-if="!myList && !reservedByMe")
        a(href="#", @click.prevent="meWants")
          b-icon(icon="heart-outline")
      .remove-reservation(v-if="!myList && reservedByMe")
        a(href="#", @click.prevent="toggleReservation")
          b-icon(icon="close")

      a.button.buy.is-success(v-if="reservedByMe && item.link" :href="item.link" target="_blank")
        b-icon.is-small(icon="cart")
        | Zur Bestellung

    zoom-y-transition(group, v-if="!editing")
      b-notification(type="is-info", has-icon, v-if="reservedByMe",
        key="300", :closable="false")
        | Dieser Artikel ist für Dich reserviert. Jetzt musst du ihn nur noch besorgen.
        | Falls du es dir anders überlegst, nimm die Reservierungeinfach wieder zurück,
        | indem du auf das rote Kreuz klickst.

    // e d i t i n g   a r e a
    .editing(v-if="editing")

      // name
      b-field(label="Name", :message="form.errors.get('name')",
              :type="form.errors.isDanger('name')")
        b-input(v-model="form.name", @keydown.native="form.errors.clear('name')")
      // description
      b-field(label="Beschreibung")
        b-input(type="textarea", v-model="form.description")
      // link
      b-field(:message="form.errors.get('link')", label="Link",
              :type="form.errors.isDanger('link')")
        b-input(placeholder="URL zum artikel", v-model="form.link", expanded,
                icon="link-variant", @keydown.native="form.errors.clear('link')")
      // image link
      b-field(label="Bild URL", :message="form.errors.get('image_url')",
              :type="form.errors.isDanger('image_url')")
        b-input(v-model="form.image_url", @keydown.native="form.errors.clear('image_url')")
      // price
      b-field(label="Preis", :message="form.errors.get('price')",
              :type="form.errors.isDanger('price')")
        b-input(v-model="form.price", @keydown.native="form.errors.clear('price')")

      .button-wrapper
        button.button.is-primary(@click="saveItem") Speichern

</template>

<script>
import Form from '@/core/Form'

export default {
  components: {
    // FadeTransition
  },
  name: 'ListItem',
  props: ['show', 'myList'],
  data () {
    return {
      item: null,
      deletionTriggered: false,
      editing: false,
      form: new Form({
        name: '',
        description: '',
        link: '',
        price: '',
        image_url: '',
        whishlist: null
      })
    }
  },
  created () {
    this.item = this.show
  },
  methods: {
    meWants () {
      this.axios.post(this.itemURL + '/me_wants').then(response => {
        // log me in if still anonymous
        if (!this.$store.state.token) {
          this.$store.commit('login', response.data.token)
        }

        // if its the first item on my new list, go to it
        if (response.data.num_items === 1) {
          this.$router.push({
            name: 'edit-list',
            params: { token: response.data.list_token },
            query: { edit: true }
          })
        } else {
          this.$toast.open('Hinzugefügt')
        }
      })
    },
    startEditing () {
      this.editing = true
      this.form.name = this.item.name
      this.form.description = this.item.description
      this.form.link = this.item.link
      this.form.image_url = this.item.image_url
      this.form.price = this.item.price
      this.form.whishlist = this.item.whishlist
    },
    saveItem () {
      this.form.submit('put', this.itemURL).then(data => {
        this.item = data
        this.editing = false
      })
    },
    deleteItem: function () {
      if (this.deletionTriggered) {
        this.axios.delete(this.itemURL)
          .then(response => {
            this.$emit('itemDeleted')
          }).catch(response => console.log(response))
      } else {
        this.deletionTriggered = true
        setTimeout(() => { this.deletionTriggered = false }, 1500)
      }
    },
    toggleReservation: function () {
      if (this.reservedByMe) {
        this.axios.post(this.reservationURL, { 'yes': false })
          .then(response => {
            this.item.reserved_by = null
          }).catch(response => console.log(response))
      } else {
        if (!this.item.reserved_by) {
          this.axios.post(this.reservationURL, { 'yes': true })
            .then(response => {
              this.item.reserved_by = response.data.token
              if (!this.$store.state.token) {
                this.$store.commit('login', response.data.token)
              }
            }).catch(response => console.log(response))
        }
      }
    }
  },
  computed: {
    deleteIcon () {
      // if (this.deletionTriggered) return "exclamation"
      if (this.deletionTriggered) return 'delete'
      return 'delete'
    },
    deleteText () {
      if (this.deletionTriggered) return 'Ja, wirklich!'
      return 'Löschen'
    },
    reservationText () {
      if (this.item.reserved_by) {
        return 'Reservierung aufheben'
      } else {
        return "Das besorg' ich!"
      }
    },
    showReservationButton () {
      return !this.item.reserved_by || this.reservedByMe
    },
    reservedByMe () {
      return this.item.reserved_by === this.$store.state.token
    },
    itemURL () {
      return `lists/${this.item.whishlist}/items/${this.item.id}`
    },
    reservationURL () {
      return this.itemURL + '/reserve/'
    },
    showOverlay () {
      return this.item.reserved_by
    },
    linkName () {
      if (this.item.name) return this.item.name
      else return this.item.link
    }
  }
}
</script>

<style lang="sass" scoped>

.me-wants, .remove-reservation
  position: absolute
  top: 5px
  .icon
    color: indianred
.me-wants, .remove-reservation
  right: 5px

@keyframes heartbeat
  0%, 20%
    transform: scale( .75 )
  40%
    transform: scale( 1 )
  60%, 100%
    transform: scale( .75 )

.herz
  animation: heartbeat 2s infinite

.burger
  width: 70px
  display: inline-block
  text-align: right

@keyframes shake
  10%, 90%
    transform: translate3d(-1px, 0, 0)

  20%, 80%
    transform: translate3d(2px, 0, 0)

  30%, 50%, 70%
    transform: translate3d(-4px, 0, 0)

  40%, 60%
    transform: translate3d(4px, 0, 0)

.dropdown-item
  .icon
    color: #067db4
    margin-right: 12px
    &.wiggle
      color: #FF6B25
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both
      transform: translate3d(0, 0, 0)
      backface-visibility: hidden

.drag-handle
  cursor: ns-resize

.section.list-item
  padding: 1em 0

p.image
  display: flex
  justify-content: center
  align-items: center
  img, a
    max-height: 128px
    max-width: 128px
    height: auto
    width: auto

.media
  position: relative

.media-right
  text-align: right

  .dropdown-item
    text-align: left
    .icon
      vertical-align: sub

span.price
  font-weight: bold

.button.reservation, .button.buy
  width: 250px
  font-weight: bold
  position: absolute
  bottom: 0
  right: 0

  .icon
    margin-right: 10px

.overlay
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 32px
  background-color: rgba(255, 255, 255, 0.7)

  img
    margin: 0 auto 0 15%
    width: 240px
    display: block

button.delete
  z-index: 1

.list-item .notification
  margin-top: 5px
  .delete::before, .delete::after, .delete, .delete:before, .delete:after
    display: none

@media screen and (max-width: 600px)

  .button.reservation, .button.buy
    width: 100%
  section.list-item
    padding: 10px 0
  article.media
    display: flex
    flex-direction: column
    align-items: center
    .media-content
      width: 100%
      padding-bottom: 60px

    figure
      text-align: center

    .item-menu
      position: absolute
      top: 0
      right: 0

</style>
